import { Injectable } from "@angular/core";

import { BehaviorSubject } from "rxjs";

import {
    MEASUREMENT_SYSTEM_INTERNATIONAL,
    MeasurementSystem,
} from "@hermes/api-model-product";

@Injectable()
export class UnitTypeService {
    public selectedUnit$ = new BehaviorSubject<MeasurementSystem>(
        MEASUREMENT_SYSTEM_INTERNATIONAL,
    );
}
